/**
 * waze — the Waze hand-off shared by the customer detail's Directions button and the
 * Run map's sheet. There is no in-app directions screen.
 */

// A browser that can't handle `waze://` fails silently, so the web link follows.
const WEB_LINK_DELAY_MS = 500;

/** Opens Waze navigating to a stop's or a station's coordinates, in the app if it can. */
export function openInWaze({ lat, lon }: { lat: string; lon: string }): void {
  window.location.href = `waze://?ll=${lat},${lon}&navigate=yes`;
  setTimeout(
    () => window.open(`https://waze.com/ul?ll=${lat},${lon}&navigate=yes`, '_blank'),
    WEB_LINK_DELAY_MS,
  );
}
